import { useState, useEffect } from "react";
import {
  Button,
  Box,
  TextField,
  Typography,
  Autocomplete,
  Avatar,
} from "@mui/material";
import { UseGeneralPages } from "../../UseGeneralPages";
import { useNavigate, useLocation } from "react-router-dom";
import ProgressCom from "../../../../components/ProgressCom";
import Detail from "../../../../main/detail/Detail";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import { rsProgress, rsActiveMenu } from "../../../../RecoilStates";
import { useRecoilState } from "recoil";
import useBreakpoints from "../../../../hooks/useBreakpoints";

export default function EditPageContact() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const navigate = useNavigate();
  const location = useLocation();
  const [brand, setBrand] = useState();
  const { UpdatePageContact, validateContact } = UseGeneralPages();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [state, setState] = useState({
    id: "",
    title: "",
    content: "",
    generalID: "",
    type: "",
  });
  const contactType = [
    { id: 1, type: "تلفن" },
    { id: 2, type: "آدرس" },
    { id: 3, type: "کد پستی" },
    { id: 4, type: "ایمیل" },
    { id: 5, type: "وب سایت" },
    { id: 6, type: "تصویر اصلی" },
  ];
  const [imgState, setImgState] = useState({
    file: undefined,
    url: state.icon ? state.icon : "",
  });
  const { isSmall } = useBreakpoints();

  const handleChangeImage = (file) => {
    setImgState({
      file: file.target.files[0],
      url: URL.createObjectURL(file.target.files[0]),
    });
  };

  useEffect(() => {
    if (location.state.model) {
      setState({
        id: location.state.model.id,
        title: location.state.model.title,
        rowIndex: location.state.model.rowIndex,
        generalID: location.state.model.generalID,
        type: location.state.model.type,
        content: location.state.model.content
          ? location.state.model.content
          : "",
      });
    }
    setImgState({
      file: undefined,
      url: location.state.model.icon ? location.state.model.icon : "",
    });
  }, [location.state]);

  const [errorState, setErrorState] = useState({
    title: false,
    content: false,
    type: false,
  });

  return (
    <Detail
      breadChilds={{
        title: "مدیریت محتوا",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/generalpages" },
          {
            name: "ویرایش صفحه",
            url: "/generalpages/pageDetail",
            targetID: location.state.id,
            scrollTo: location.state.scrollTo,
          },
          {
            name: "ویرایش اطلاعات تماس",
            url: "/generalpages/pageDetail/editPageContact",
          },
        ],
      }}
    >
      {!brand ? (
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box gridColumn={isSmall ? "span 12" : "span  4"}>
            <TextField
              fullWidth
              value={state.title ? state.title : ""}
              error={errorState.title}
              label="عنوان"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, title: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 8"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span  3"}>
            <Autocomplete
              size="small"
              onChange={(event, newValue) => {
                setState({ ...state, type: newValue });
              }}
              value={state.type ? state.type : ""}
              isOptionEqualToValue={(option, value) => {
                return value == "" || option === value;
              }}
              getOptionLabel={(option) => {
                if (option) {
                  return contactType.find((m) => m.id == option).type;
                }
                return "";
              }}
              options={contactType?.map((m) => m.id)}
              renderInput={(params) => (
                <TextField
                  error={errorState.type}
                  variant="outlined"
                  {...params}
                  label="نوع"
                />
              )}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box
            gridColumn={isSmall ? "span 12" : "span  4"}
            sx={{ display: "flex", alignItems: "center" }}
          >
            <Box component="label">
              <Avatar
                sx={{
                  border: "2px dashed #0073E7",
                  borderRadius: 4,
                  boxShadow: 0,
                  cursor: "pointer",
                  width: state.type == 6 ? "360px" : "100px",
                  height: state.type == 6 ? "100px" : "100px",
                  p: 1,
                }}
                src={imgState.url ? imgState.url : "/static/img/nobanner.jpg"}
                alt="img"
              />
              <input
                type="file"
                id="img"
                name="avatarName"
                accept="image/*"
                multiple
                onChange={handleChangeImage}
                hidden
              />
            </Box>
          </Box>
          {!isSmall && <Box gridColumn="span 6"></Box>}
          <Box gridColumn="span 12">
            <Typography color="secondary" sx={{ mb: 1 }} variant="subtitle1">
              متن :
            </Typography>
            <CKEditor
              config={{
                language: "fa",
                link: {
                  decorators: {
                    addTargetToExternalLinks: {
                      mode: "automatic",
                      callback: (url) => /^(https?:)?\/\//.test(url),
                      attributes: {
                        target: "_blank",
                        rel: "noopener noreferrer",
                      },
                    },
                  },
                },
              }}
              editor={Editor}
              style={{ width: "100%" }}
              data={state.content ? state.content : ""}
              onChange={(event, editor) => {
                const data = editor.getData();
                if (state.id) {
                  setState({ ...state, content: data });
                }
              }}
              error={errorState.content}
              onReady={(editor) => {
                editor.editing.view.change((writer) => {
                  writer.setStyle(
                    "height",
                    "300px",
                    editor.editing.view.document.getRoot()
                  );
                });
              }}
            />
          </Box>
          <Box
            sx={{ display: "flex", justifyContent: "center" }}
            gridColumn="span 12"
          >
            <Button
              sx={{ mr: 2, width: "100px" }}
              variant="contained"
              color="secondary"
              onClick={() => {
                if (validateContact(state, setErrorState) == 200) {
                  setProgress(true);
                  UpdatePageContact(state, imgState.file, () => {
                    navigate("/generalpages/pageDetail", {
                      state: { ...location.state, isBack: true },
                      replace: true,
                    });
                  });
                }
              }}
            >
              ثبت
            </Button>
            <Button
              sx={{ width: "100px" }}
              variant="outlined"
              color="secondary"
              onClick={() => {
                navigate("/generalpages/pageDetail", {
                  state: { ...location.state, isBack: true },
                  replace: true,
                });
              }}
            >
              بازگشت
            </Button>
          </Box>
        </Box>
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}
